import { render, staticRenderFns } from "./ExhibitorshallMobile.vue?vue&type=template&id=12476b2b&"
import script from "./ExhibitorshallMobile.vue?vue&type=script&lang=js&"
export * from "./ExhibitorshallMobile.vue?vue&type=script&lang=js&"
import style0 from "./ExhibitorshallMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports